var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 0C10.907 0.00339686 7.94152 1.23365 5.75434 3.42084C3.56715 5.60803 2.33689 8.57352 2.3335 11.6667C2.3335 17.829 12.1335 26.2885 13.2465 27.2335L14.0002 27.8705L14.7538 27.2335C15.8668 26.2885 25.6668 17.829 25.6668 11.6667C25.6634 8.57352 24.4332 5.60803 22.246 3.42084C20.0588 1.23365 17.0933 0.00339686 14.0002 0ZM14.0002 17.5C12.8464 17.5 11.7186 17.1579 10.7593 16.5169C9.80005 15.8759 9.05238 14.9649 8.61087 13.899C8.16935 12.8331 8.05384 11.6602 8.27892 10.5286C8.504 9.39709 9.05957 8.35768 9.87537 7.54188C10.6912 6.72607 11.7306 6.1705 12.8621 5.94542C13.9937 5.72034 15.1666 5.83586 16.2325 6.27737C17.2984 6.71888 18.2094 7.46655 18.8504 8.42584C19.4914 9.38513 19.8335 10.5129 19.8335 11.6667C19.8316 13.2132 19.2165 14.6959 18.1229 15.7894C17.0293 16.883 15.5467 17.4981 14.0002 17.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1666C15.933 15.1666 17.5 13.5996 17.5 11.6666C17.5 9.73363 15.933 8.16663 14 8.16663C12.067 8.16663 10.5 9.73363 10.5 11.6666C10.5 13.5996 12.067 15.1666 14 15.1666Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.eb6125c557d64f8eb6ad2c18a8c0e0da.svg";
export { ForwardRef as ReactComponent };